import { EditorThemeClasses, TextFormatType } from 'lexical';

export type SupportedTextFormatType = Extract<TextFormatType, 'bold' | 'italic' | 'underline'>;
export type SupportedListNodeTagType = 'ul' | 'ol';
export type SupportedFeatures =
    | SupportedTextFormatType
    | SupportedListNodeTagType
    | 'headingStyle'
    | 'link'
    | 'fontColor';

export const allSupportedFeatures: SupportedFeatures[] = [
    'bold',
    'headingStyle',
    'italic',
    'ol',
    'ul',
    'underline',
    'link',
    'fontColor',
];

export const editorTheme: EditorThemeClasses = {
    text: {
        bold: 'bold',
        italic: 'italic',
        underline: 'underline',
    },
    list: {
        listitem: 'listItem',
        listitemChecked: 'listItemChecked',
        listitemUnchecked: 'listItemUnchecked',
        nested: {
            listitem: 'nestedListItem',
        },
        olDepth: ['ol1', 'ol2', 'ol3', 'ol4', 'ol5'],
        ul: 'ul',
    },
};
